import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgClass } from '@angular/common';

export type userInitialsIconAppearance = 'dark' | 'light';

@Component({
  selector: 'ticketing-initials-icon',
  imports: [NgClass],
  templateUrl: './user-initials-icon.component.html',
  styleUrl: './user-initials-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserInitialsIconComponent {
  appearance = input.required<userInitialsIconAppearance>();
  user = input.required<{ givenName: string; surname: string } | undefined>();
  userInitials = computed(() => {
    const user = this.user();
    if (user !== undefined) {
      return user.givenName.substring(0, 1).toLocaleUpperCase() + user.surname.substring(0, 1).toLocaleUpperCase();
    } else {
      return null;
    }
  });
}
